import React from 'react'
import Loading from '../../../components/Loading'

const ManagerApprovalStatus = ({ managerApprovalStatusInfo, setCurrentStep, managerApprovalStatusResponse, managerApprovalStatusNotRequired = null }) => {
  let style = 'is-warning';
  if (managerApprovalStatusInfo?.code_key == "mgr_approval_status_approved") {
    style = 'is-success';
  } else if (managerApprovalStatusInfo?.code_key == "mgr_approval_status_declined") {
    style = 'is-danger';
  }

  let managerApprovalStatus = "Approval Required";
  if (managerApprovalStatusNotRequired === true) {
    managerApprovalStatus = "Approval Not Required";
  } else if (managerApprovalStatusInfo?.code_key) {
    if (managerApprovalStatusInfo?.code_key !== "mgr_approval_status_required") {
      managerApprovalStatus = managerApprovalStatusInfo?.name;
    } else {
      managerApprovalStatus = "Approval Request Processing";
    }
  }

  let displayLoader = false
  if (managerApprovalStatusInfo?.code_key && managerApprovalStatusInfo?.code_key != "mgr_approval_status_approved" && managerApprovalStatusInfo?.code_key != "mgr_approval_status_declined") {
    displayLoader = true
  }

  return (
    <div className="is-full py-0 mt-3">
      <div className={`notification ${style} is-light`}>
        <div className="title is-4 has-text-primary is-flex">
          Manager Approval Status: {managerApprovalStatus}
          {displayLoader && <Loading size="is-size-6" />}
        </div>
        {managerApprovalStatusInfo?.code_key == "mgr_approval_status_declined" && (
          <p className="subtitle is-6">Declined Reason: {managerApprovalStatusResponse?.description}<br />
            <button type="button" className="button has-background-grey has-text-white is-small px-2" onClick={() => setCurrentStep(0)}>Fix Details</button>
          </p>
        )}
      </div>
    </div>
  )
};

export default ManagerApprovalStatus;
